import { MissionEventRecord } from "../types";
import { MissionRecord } from "../types";
import { missionActive } from "../functions";
import { useOrganPermission } from "../../../permissions";

export const isEta = (event: MissionEventRecord): boolean =>
	!!(event.eta && !event.time);

export const eventMarked = (event: MissionEventRecord): boolean =>
	!!(event.time || event.eta);

export const displayTime = (event: MissionEventRecord): string =>
	(event.time || event.eta) as string;

export const useShowMissionEventActions = (mission: MissionRecord) => {
	const { hasPermissionInOrgan: eventEditingPermission } = useOrganPermission(
		"mission-events.update"
	);

	return (
		mission &&
		missionActive(mission) &&
		eventEditingPermission(mission.organ_id)
	);
};
